import React from "react";
import { Box, Typography } from "@mui/material";
import ShowOrDash from "./ShowOrDash.web";

interface ListProps {
  items: string[];
  visibleCount?: number;
  delimiter?: React.ReactNode;
}

const LanguageList: React.FC<ListProps> = ({
  items,
  visibleCount = 4,
  delimiter = (
    <Box
      sx={{
        height: "16px",
        width: "1px",
        borderRight: "1px solid #010101",
        mx: 1,
      }}
    />
  ),
}) => {
  const visibleItems = items.slice(0, visibleCount);
  const remainingItems = items.slice(visibleCount).join(", ");
  const hasAdditionalItems = items.length > visibleCount;

  return (
    <Box style={{ display: "flex" }}>
      <ShowOrDash condition={items.length > 0}>
        {visibleItems.map((item, index) => (
          <React.Fragment key={item}>
            <Typography component="span" sx={{ color: "#010101" }}>
              {item}
            </Typography>
            {index < visibleItems.length - 1 && delimiter}
          </React.Fragment>
        ))}
        {hasAdditionalItems && (
          <>
            {delimiter}
            <Typography
              component="span"
              title={remainingItems}
              sx={{ cursor: "default", color: "#010101", fontWeight: "bold" }}
            >
              {`${items.length - visibleCount}+`}
            </Typography>
          </>
        )}
      </ShowOrDash>
    </Box>
  );
};

export default LanguageList;
